<template>
  <div class="grd txt">
    <div class="fk2">
      &nbsp;
    </div>
    <div class="fk">
      <span>{{ $t('Webportal.DashboardBMW.FocusKPI') }}</span>
    </div>
    <div class="pe">
      <span>{{ $t('Webportal.DashboardBMW.MysProcess') }}<br>{{ $t('Webportal.DashboardBMW.Excellence') }} (%)</span>
    </div>
    <div class="ct">
      <span>{{ $t('Webportal.DashboardBMW.MysCustomer') }}<br>{{ $t('Webportal.DashboardBMW.Treatment') }} ({{ $t('Webportal.Dashboard.NPS') }})*</span>
    </div>
    <div class="lfu">
      <span>{{ $t('Webportal.DashboardBMW.Lead') }}<br>{{ $t('Webportal.DashboardBMW.FollowUp') }} (%)</span>
    </div>
    <div class="afu">
      <span>{{ $t('Webportal.DashboardBMW.Appointment') }}<br>{{ $t('Webportal.DashboardBMW.FollowUp') }} (%)</span>
    </div>

    <div class="pe2">
      &nbsp;
    </div> 

    <div class="lm1">
      <span v-if="showBowls" class="bowl">
        <font-awesome-layers>
          <font-awesome-icon  icon="circle" class="glow"
                              transform="grow-8"   />
          <font-awesome-icon  :icon="['fas', 'trophy']"
                              style="color: white;"
                              transform="shrink-2 left-1"  />
        </font-awesome-layers>
        &nbsp;
      </span>
      <span>Legendary Moment:<br>Test Drive (%)</span> 
    </div>
    <div class="lm2">
      <span v-if="showBowls" class="bowl">
        <font-awesome-layers>
          <font-awesome-icon  icon="circle" class="glow"
                              transform="grow-8"   />
          <font-awesome-icon  :icon="['fas', 'trophy']"
                              style="color: white;"
                              transform="shrink-2 left-1"  />
        </font-awesome-layers>
        &nbsp;
      </span>
      <span>Legendary Moment:<br><span v-if="showBowls">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>Integrated offer (%)</span> 
    </div>
    <div class="lm3"><span>xEV Readiness (%)</span></div>
    <div class="lm4"><span>My BMW/MINI App (%)</span></div>

    <div class="pe3">
      &nbsp;
    </div>
  </div>
</template>

<script>

export default {
  props: {
    dashdata: { type: Object, default: undefined },
    showBowls: { type: Boolean, required: false, default: false }
  }
};

</script>

<style lang="scss" scoped>
  @import "@/../scss/bmw/_variables_compareBoard.scss";
  @import "@/../scss/bmw/_variables.scss";
  $bmw-2021-bd-width: 1px;

  .txt {
    font-size: 8pt;
    text-align: center;
    text-transform: uppercase;
    line-break: auto;
  }
  .grd {
    display: grid;
    width: 10rem;
    height: $item-height;
    grid-template-areas: "fk2 fk fk"
                         "fk2 pe pe"
                         "fk2 pe2 lfu"
                         "fk2 pe2 afu"
                         "fk2 .  ."
                         "fk2 pe3 lm1"
                         "fk2 pe3 lm2"
                         "fk2 pe3 lm3"
                         "fk2 pe3 lm4"
                         "fk2 .  ."
                         "fk2 ct ct";
    grid-template-rows: 10fr 10.5fr 10.5fr 10.5fr 1fr 10.5fr 10.5fr 10.5fr 10.5fr 1fr 7fr;
    grid-template-columns: 2fr 2fr 26fr;
  }
  .fk, .fk2 {
    background-color: $bmw-bg21;
  }
  .pe, .lfu, .afu, .lm1, .lm2, .lm3, .lm4 {
    padding-top: 7%;
  }
  .pe, .pe2, .pe3, .ct, .ct2 {
    background-color: $bmw-2021-bg-light;
  }
  .lfu, .afu, .lm1, .lm2, .lm3, .lm4 {
    background-color: $bmw-2021-bg-verylight;
  }
  .pe, .ct, .lfu, .afu, .lm1, .lm2, .lm3, .lm4 {
    border-right: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .pe2, .pe3, .ct2, .afu, .lm4 {
    border-bottom: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .ct, .afu, .lfu, .lm1, .lm2, .lm3, .lm4 {
    border-top: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .afu, .lfu, .lm1, .lm2, .lm3, .lm4 {
    border-left: $bmw-2021-bd-width $bmw-2021-bd-style $bmw-bd21;
  }
  .fk, .pe, .ct {
    color: $bmw-2021-fg;
    font-weight: bold;
    letter-spacing: 0.02em;
  }
  .fk {
    grid-area: fk;
    padding-top: 12%;
    font-size: 10pt;
    height: 3.2rem;
  }
  .fk2 {
    grid-area: fk2;
  }
  .pe {
    grid-area: pe;

  }
  .pe2 {
    grid-area: pe2;
  }
  .pe3 {
    grid-area: pe3;
  }
  .ct {
    grid-area: ct;
  }
  .ct2 {
    grid-area: ct2;
  }
  .lfu {
    grid-area: lfu;
  }
  .afu {
    grid-area: afu;
  }
  .lm1 {
    grid-area: lm1;
  }
  .lm2 {
    grid-area: lm2;
  }
  .lm3 {
    grid-area: lm3;
  }
  .lm4 {
    grid-area: lm4;
  }

  .glow {
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
  }

  .bowl {
    padding-top: 1.0rem;
    color: red;
  }
</style>
